/* DialectNotificationComponent.tsx */
'use client'

import '@dialectlabs/react-ui/index.css'
import { useSelector, useDispatch } from 'react-redux'

import { DialectSolanaSdk } from '@dialectlabs/react-sdk-blockchain-solana'
import { NotificationsButton } from '@dialectlabs/react-ui'

// styles
import styles from './index.module.scss'

/* Set DAPP_ADDRESS variable to the public key generated in previous section */
const DAPP_ADDRESS_DEVNET = 'diaVSXtyPsBdACK1RYCo4pCjaHmshZ6b7Rmc9saa637'
const DAPP_ADDRESS_MAINNET = 'fosAxudEChWgmCf1noRTHvRurMJ71dSqKMzEf3C9SbU'
const DAPP_ADDRESS = process.env.WALLET_ADAPTER_NETWORK == 'mainnet-beta' ? DAPP_ADDRESS_MAINNET : DAPP_ADDRESS_DEVNET

export const DialectNotificationComponent = () => {
  const lightDarkMode = useSelector(state => (state as any).lightMode)
  const dispatch = useDispatch()
  return (
    <div
      className={styles.dialectNoficiation}
      onClick={() => {
        dispatch({ type: 'set', openMobileMenu: false })
      }}
    >
      <DialectSolanaSdk dappAddress={DAPP_ADDRESS}>
        <NotificationsButton theme={lightDarkMode ? 'light' : 'dark'} />
      </DialectSolanaSdk>
    </div>
  )
}
